module.exports = __webpack_public_path__ + "static/cbam-comparing-2-a4ca418135f77861469c82991fdd84a5.png";